import {
  CORE_FLIGHTS_CFAR_NAME,
  type CoreFlightsCfarOffersComponents,
  type CoreFlightsCfarExerciseComponents,
} from "@b2bportal/core-types";
import { useStyles } from "../context";

export const useCfarStyles = (
  componentName:
    | keyof typeof CoreFlightsCfarOffersComponents
    | keyof typeof CoreFlightsCfarExerciseComponents,
  defaultStyles?: object
) => {
  return useStyles(CORE_FLIGHTS_CFAR_NAME, componentName, defaultStyles);
};
